export default __webpack_public_path__ + "static/6826-9006fd4d94ec3b606b902ad089132f7d.jpg";